import { put, call, take, fork } from 'redux-saga/effects'
import { questionListService } from '../../api/question'
import { questionListSuccess } from '../../reducers/question/action'
import { QUESTION_LIST } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionListFlow(payload) {
  try {
    const { query } = payload
    const response = yield call(questionListService, query)
    if (
      response.data.results.length == 0 &&
      query.FilterText == '' &&
      query.Filters == undefined
    ) {
      response.data.results = null
    }
    yield put(questionListSuccess(response.data))
    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionListWatcher() {
  while (true) {
    const action = yield take(QUESTION_LIST)
    const { payload } = action
    yield fork(generalSaga, questionListFlow, payload)
  }
}
